import React, { useState, useEffect } from 'react';
import { getChefSpecials } from '../services/api';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';

const ChefsSpecial = () => {
  const [chefsSpecials, setChefsSpecials] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await getChefSpecials();
        setChefsSpecials(data);
      } catch (error) {
        console.error('Error fetching specials:', error);
        const savedSpecials = localStorage.getItem('chefsSpecials');
        if (savedSpecials) setChefsSpecials(JSON.parse(savedSpecials));
      }
    };
    fetchData();
  }, []);

  return (
    <section id="specials" className="py-24 px-4" style={{ backgroundColor: '#FFCCE0' }}>
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2
            className="md:text-6xl !font-bold !text-5xl mb-4"
            style={{ fontFamily: "'Crimson Text', serif" }}>Especialidades del chef


          </h2>
          <p className="max-w-2xl !text-lg mx-auto text-gray-700">Las recomendaciones de nuestra chef ejecutiva. Elaborados con ingredientes de temporada y técnicas clásicas francesas.

          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {chefsSpecials.map((special) => (
            <Card 
              key={special.id} 
              className="overflow-hidden hover:shadow-xl transition-shadow duration-300"
              style={{ backgroundColor: '#ffffff' }}
            >
              <CardHeader>
                <div className="flex justify-between items-start mb-2">
                  <CardTitle className="text-3xl" style={{ fontFamily: "'Crimson Text', serif" }}>
                    {special.name}
                  </CardTitle>
                  <Badge className="bg-black text-white text-lg px-4 py-2">
                    ${special.price.toFixed(2)}
                  </Badge>
                </div>
                <p className="text-sm text-gray-600 italic">By {special.chef}</p>
              </CardHeader>
              <CardContent>
                <CardDescription className="text-gray-700 text-base">
                  {special.description}
                </CardDescription>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>);

};

export default ChefsSpecial;